import type { AboutCandidatePayload } from '@Application/Subjects/Actions/aboutCandidatesFetched';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';

/** A person or facility a dossier can be about. The `kind` and `id` pair is its identity. */
class AboutCandidateView {
	readonly kind: LabeledValueView;
	readonly id: number;
	readonly name: string;
	readonly detail: string | null;

	constructor(payload: AboutCandidatePayload) {
		this.kind = new LabeledValueView(payload.kind);
		this.id = payload.id;
		this.name = payload.name;
		this.detail = payload.detail;

		Object.freeze(this);
	}
}

export default AboutCandidateView;
